<template>
  <el-dialog custom-class="early-warning-dialog" :visible.sync="visible" :before-close="onClose" center width="50%">
    <div class="dialogtitle">
      <div class="titlebg">
        <img src="../../assets/警告@2x.png" alt="" />
        <span> 请确认以下预警 </span>
      </div>
    </div>
    <div class="dialogtable">
      <el-table ref="multipleTable" :data="dataList" style="width: 100%" max-height="350">
        <el-table-column type="selection" width="55">
        </el-table-column>
        <el-table-column prop="belong" label="预警类目" align="center"></el-table-column>
        <el-table-column prop="message" label="类目描述" align="center"></el-table-column>
        <el-table-column prop="alarm" label="预警级别" align="center">
          <template slot-scope="scope">
            {{ { 1: "低级", 2: "中级", 3: "高级" }[scope.row.alarm] }}
          </template>
        </el-table-column>
        <el-table-column prop="tag" label="预警点位" align="center"></el-table-column>
        <el-table-column prop="value" label="当前值" width="180" align="center"></el-table-column>
        <el-table-column prop="time" label="预警时间" align="center"></el-table-column>
      </el-table>
      <div class="knowbtn">
        <el-button type="primary" plain @click="updatewarning()">已知悉</el-button>
      </div>
    </div>

  </el-dialog>
</template>

<script>
import config from '@/utils/config';

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    dataList: {
      type: Array,
      default: () => ([]),
    }
  },
  methods: {
    onClose() {
      this.$emit("onClose");
    },
    async updatewarning() {
      console.log('获取统计');
      const selectData = this.$refs.multipleTable.selection
      console.log(selectData);
      let ids = []
      let haveid = true
      selectData.map((v, i) => {
        if (v.id) {
          ids.push(v.id)
        } else {
          haveid = false
        }
      })
      console.log(haveid);

      // return
      if (haveid) {
        if (selectData.length > 0) {
          let form = {
            ids: ids,
            status: 1
          }
          // return
          const { data: res } = await this.$http.put(
            config.httpPrefix + "/prewarning/update/status",
            form
          );
          if (res.code == 200) {
            this.$emit("onClose");
          }
        } else {
          return this.$message.error('请选择至少一条预警');
        }
      } else {
        this.$emit("onClose");
      }

    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog.early-warning-dialog {
  opacity: 1;
  border-radius: 35px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 12px 50px 9px rgba(222, 60, 60, 0.25);

  .el-dialog__body {
    max-height: 900px;
    overflow: auto;
  }

  .dialogtitle {
    height: 58px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 50px;

    .titlebg {
      width: 795px;
      border-radius: 159px;
      background: rgba(254, 236, 234, 1);
      display: flex;
      justify-content: center;
      align-items: center;
    }

    img {
      width: 30px;
      height: 26px;
    }

    span {
      font-size: 24px;
      font-weight: 400;
      letter-spacing: 0px;
      line-height: 58px;
      color: rgba(212, 48, 48, 1);
      text-align: left;
      vertical-align: middle;
    }
  }

  .knowbtn {
    margin-top: 10px;
    display: flex;
    text-align: center;
    justify-content: center;
  }
}
</style>